module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inviteAssociate":"Invite new member","noAccountsFound":"No {roleLabel} accounts found.","education":"Education","removeUser":"Remove User","editUser":"Edit User"}}')
  delete Component.options._Ctor
}
